import { render } from "./MoreDetailsHeader.vue?vue&type=template&id=4213c77f&scoped=true"
import script from "./MoreDetailsHeader.vue?vue&type=script&lang=js"
export * from "./MoreDetailsHeader.vue?vue&type=script&lang=js"

import "./MoreDetailsHeader.vue?vue&type=style&index=0&id=4213c77f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4213c77f"]])

export default __exports__